import { TIssueStatus } from "@mctypes/global.types";
import { trpcSlice } from "../trpcSlice";

export const notificationRTK = trpcSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationIssueStatuses: builder.query<
      { issueId: string; status: TIssueStatus }[],
      { issueIds: string[] }
    >({
      query: (body) => ({
        url: "/notifications/issue-statuses",
        method: "POST",
        body,
      }),
      providesTags: ["NotificationIssueStatuses"],
    }),
  }),
});

export const { useGetNotificationIssueStatusesQuery } = notificationRTK;
